import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getFormattedDate } from '../../../../../utils/date-utils/dateUtils';
import styles from '../restricted_modal.module.scss';
import { RestrictedModalLayout } from '../RestrictedModalLayout';
import { ModalRestrictedContainer } from '../../modal-container/ModalRestrictedContainer';
import { useUser } from '../../../../../user/useUser';
import { BrandHyperlink } from '../../../../button/brand/BrandHyperlink';

type Props = {
  closeModal: () => void;
  source: string;
  isOpen: boolean;
};

export const ExpiredRestrictedModal: FC<Props> = ({
  closeModal,
  source,
  isOpen,
}) => {
  const { currentUser } = useUser();
  return (
    <ModalRestrictedContainer onRequestClose={closeModal} isOpen={isOpen}>
      <RestrictedModalLayout closeModal={closeModal} source={source}>
        <span className={styles.logo} />
        <div className={styles.title}>
          <FormattedMessage
            id="expired/ExpiredRestrictedModal.tsx/1"
            values={{
              br: <br />,
              date: getFormattedDate(currentUser.expirationDate),
            }}
          />
        </div>
        <span className={styles.subtitle}>
          <FormattedMessage
            id="expired/ExpiredRestrictedModal.tsx/2"
            values={{ br: <br /> }}
          />
        </span>
        <div className={styles.startButton}>
          <BrandHyperlink
            large
            href="/tarifs"
            source={source}
            iconLeft="arrow_forward"
          >
            <FormattedMessage id="expired/ExpiredRestrictedModal.tsx/3" />
          </BrandHyperlink>
        </div>
        <div className="restricted-modal__bottom" />
      </RestrictedModalLayout>
    </ModalRestrictedContainer>
  );
};
